import {UI, type UICleanChild, type UIRenderable} from "../../stem-core/ui/UIBase";
import {MessageElement} from "../../blinkpay/widget/ui/MessageElement.jsx";

export function BlinkMakeText(text: UICleanChild | UIRenderable, options?: Record<string, any>) {
    return <MessageElement message={text} {...options} />;
}
